// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id="customer-deposit-accounts-check-deposit" class="box product-operation">
  <sub-header header="'Interest check withdrawal'"></sub-header>
    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product name:</span>
        <span class="value">{{\$ctrl.termDeposit.productName}}</span>
      </div>
      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value"
              ng-class="{'currency--positive': \$ctrl.termDeposit.balance > 0, 'currency--negative': \$ctrl.termDeposit.balance < 0}">
          {{\$ctrl.termDeposit.balance | nxCurrency}}
        </span>
      </div>
      <div class="override">
        <span class="key">Override withdraw amount:</span>
        <span class="value">
          <input type="checkbox"
                 ng-model="\$ctrl.overrideCheckbox"
                 ng-disabled="\$ctrl.termDeposit.depositSubgroup === 'ADVANCE_INTEREST'"/>
        </span>
      </div>
    </div>

    <form name="\$ctrl.transactionForm">
      <table class="misc-transaction__table table table--generate-row-ids">
        <thead>
        <tr ng-if="\$ctrl.overrideCheckbox">
          <td></td>
          <td></td>
          <td ng-if="\$ctrl.overrideCheckbox">
            Default
          </td>
          <td><span ng-if="\$ctrl.overrideCheckbox">Override</span></td>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td></td>
          <td>Gross interest</td>
          <td>
            <cash ng-model="\$ctrl.interestForecast.interest"
              ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox">
            <cash ng-model="\$ctrl.override.interest"
              ng-change="\$ctrl.updateOverrides()"
              ng-required="true"></cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Withholding tax</td>
          <td>
            <cash ng-model="\$ctrl.interestForecast.withholdingTax"
              ng-disabled="true"></cash>
          </td>

          <td ng-if="\$ctrl.overrideCheckbox && \$ctrl.taxRecalculated">
            <cash ng-model="\$ctrl.override.withholdingTax"
              ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox && !\$ctrl.taxRecalculated">
            <button class="btn btn-info" id="recalculate-tax-btn" ng-click="\$ctrl.recalculateTax()">Recalculate tax</button>
          </td>

        </tr>
        <tr>
          <td></td>
          <td>Net interest</td>
          <td>
            <cash ng-model="\$ctrl.interestForecast.netInterest"
              ng-disabled="true"></cash>
          </td>

          <td ng-if="\$ctrl.overrideCheckbox && \$ctrl.taxRecalculated">
            <cash ng-model="\$ctrl.override.netInterest"
              ng-disabled="true"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox && !\$ctrl.taxRecalculated">
            <cash ng-disabled="true"></cash>
          </td>

        </tr>
        <tr>
          <td></td>
          <td>Withdrawal amount:</td>
          <td>
            <cash ng-disabled="true" ignore-amount-validation="\$ctrl.overrideCheckbox" ng-model="\$ctrl.withdrawalAmount"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox && \$ctrl.taxRecalculated">
            <cash ng-disabled="true" ng-model="\$ctrl.override.amount"></cash>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox && !\$ctrl.taxRecalculated">
            <cash ng-disabled="true"></cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Check number</td>
          <td>
            <input
              required
              type="text"
              class="check-no"
              ng-model="\$ctrl.checkNumber"
              ng-change="\$ctrl.updateMicr()"
              ui-mask="9999999999"
              ng-minlength="10"
              ng-maxlength="10"/>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox"></td>
        </tr>
        <tr>
          <td></td>
          <td>Valid from</td>
          <td>
            <date output-format="date"
              ng-model="\$ctrl.validFrom"
              ng-required="true"></date>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox"></td>
        </tr>
        <tr>
          <td></td>
          <td>Check account</td>
          <td>
            <selectize options="\$ctrl.checkingAccounts"
                       config="\$ctrl.selectConfig"
                       ng-model="\$ctrl.depositoryAccountId"
                       ng-change="\$ctrl.updateMicr()"
                       ng-required="true">
            </selectize>
          </td>
          <td ng-if="\$ctrl.overrideCheckbox"></td>
        </tr>
        <tr>
          <td></td>
          <td>Remarks</td>
          <td>
            <input type="text"
                   ng-model="\$ctrl.remarks"
                   ng-required="false">
          </td>
          <td ng-if="\$ctrl.overrideCheckbox"></td>
        </tr>
        </tbody>
      </table>
      <div class="buttons">
        <signature-card
          file-id="\$ctrl.termDeposit.signatureCardFileId"
          product-group="'DEPOSIT'"
          product-status="\$ctrl.termDeposit.status"></signature-card>
        <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
        <button class="btn btn-danger" ng-click="\$ctrl.withdraw()"
                ng-disabled="\$ctrl.transactionForm.\$invalid || !\$ctrl.withdrawalEnabled()  || (\$ctrl.overrideCheckbox && !\$ctrl.taxRecalculated)">
          Withdraw
        </button>
      </div>
    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/interests-check-withdrawal/interests-check-withdrawal.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;